import { Component, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Price } from '../models/price';
import { PriceService } from '../services/price.service';
import { MatDialog } from '@angular/material/dialog';
import { PriceListQueryFilter } from './price-list-query-filter';
import { Sort } from '@angular/material/sort';
import { PriceCreateModalComponent } from '../modals/price/price-create-modal/price-create-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { PriceEditModalComponent } from '../modals/price/price-edit-modal/price-edit-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';

@Component({
    selector: 'prices-list',
    templateUrl: './prices-list.component.html',
    styleUrl: './prices-list.component.scss',
    standalone: false
})
export class PricesListComponent extends BaseComponent{
  @Input() filter: PriceListQueryFilter = new PriceListQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public prices: Price[] = [];
  
  constructor(sessionService: SessionService,
    private priceService: PriceService,
    private dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['bayNumber', 'bayName', 'priceBandName', 'amount', 'durationMinutes', 'lastEditedDate', 'actions'];
    this.filter.organizationId = this.sessionService.getUser().organizationId;
  }

  ngOnInit(): void {
    this.getPrices();
  }

  getPrices(){
    this.isLoading = true;
    this.priceService.getAllByOrganization(this.filter).subscribe({
      next: (result) => {
        this.prices = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getPrices();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  createBand(){
    const dialogRef = this.dialog.open(PriceCreateModalComponent, {
      width: '40vw'
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getPrices();
      }
    });
  }

  edit(price: Price){
    const dialogRef = this.dialog.open(PriceEditModalComponent, {
      width: '40vw',
      height: 'auto'
    });

    dialogRef.componentInstance.price = price;

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getPrices();
      }
    });
  }

  delete(price: Price){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Price';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Price <strong>${price.priceBandName}</strong>?`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        let data = {id: price.id, lastEditedBy: this.getUserIdFromSession()};
        this.priceService.delete(data).subscribe({
          next: () => {
            this.getPrices();
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            console.error(error); 
          },
          complete: () => this.isLoading = false
        });
      }
    });
  }
}
